import { useRegisterSW } from 'virtual:pwa-register/react';
import { useEffect } from 'react';
import { toast } from '@/components/ui/toaster.tsx';

const CHECK_FOR_UPDATES_MS = 60 * 60 * 1000;

/**
 * PWA updates use registerType 'prompt': a new version downloads in the background and waits
 * until someone taps "Reload" — never a surprise refresh in the middle of typing an entry.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      // Phones can keep the app open for days; look for a new version every hour.
      if (registration) setInterval(() => void registration.update(), CHECK_FOR_UPDATES_MS);
    },
  });

  useEffect(() => {
    if (!needRefresh) return;
    toast('A new version of the planner is ready.', {
      id: 'pwa-update',
      duration: Number.POSITIVE_INFINITY,
      description: 'Reload when you’re done with what you’re typing.',
      action: { label: 'Reload', onClick: () => void updateServiceWorker(true) },
    });
  }, [needRefresh, updateServiceWorker]);

  return null;
}

/** The API refused this (old) build — ask for a reload. Offline entries stay queued on the phone. */
export function showStaleClientToast(): void {
  toast.warning('This copy of the planner is out of date.', {
    id: 'stale-client',
    duration: Number.POSITIVE_INFINITY,
    description: 'Reload to get the latest version. Anything waiting to sync is kept.',
    action: { label: 'Reload', onClick: () => window.location.reload() },
  });
}
